export enum EntityType {
  AGENT = 'AGENT',
  PROPERTY = 'PROPERTY',
}
